// https://www.dbos.dev/partners

import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaBuildYourReliableBackend } from '@components/layout/FooterCtas';
import {
  ListFilterCount,
  ListFilterItem,
  ListFilterLabel,
  ListFilterRadio,
  ListFilterScope,
  ListFilterWrapper,
  SlideIn,
} from '@components/interactions';
import { FaqAccordion, FaqAnswer, FaqIcon, FaqQuestion, FormDone, FormElement, FormFail } from '@components/webflow';

export function PartnersPage() {
  return (
    <SiteLayout banner={true} footerCta={<FooterCtaBuildYourReliableBackend />}>
      <style
        dangerouslySetInnerHTML={{
          __html:
            '.is-list-filtering {\n/* Used to fade between filtering */\n/* Timing adjusted at the wrapper level */\nopacity: 0;\n}',
        }}
      />
      <section className="section_partnerships-new">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large">
              <div className="pricing_component">
                <div className="text-align-center">
                  <div className="max-width-medium">
                    <div className="margin-bottom margin-xsmall">
                      <div className="tagline-container_glow">
                        <h1 className="text-size-small tagline-container is-glow">{'Partners &\u00a0Integrations'}</h1>
                      </div>
                    </div>
                    <div className="margin-bottom margin-xsmall">
                      <h2 className="heading-style-h1">Partnerships</h2>
                    </div>
                    <p className="text-body-active">
                      DBOS works with leading partners in the durable execution and AI workflow orchestration ecosystem.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_partner-list">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-small">
              <ListFilterScope className="filter-form-wrapper margin-bottom margin-small w-form" as="div">
                <FormElement
                  id="email-form"
                  name="email-form"
                  data-name="Email Form"
                  method="get"
                  fs-list-element="filters"
                  className="filter-form"
                >
                  <div className="filter_tags-wrapper">
                    <p className="text-body-active newhomebody text-weight-medium">Filter by type</p>
                    <div className="filter_tags">
                      <ListFilterLabel className="filter-item is-list-active w-radio" as="label" filterValue="">
                        <ListFilterRadio
                          fs-list-value=""
                          className="w-form-formradioinput partnerships_radio w-radio-input"
                          fs-list-field="partner"
                          name="partner"
                          data-name="partner"
                          type="radio"
                          id="radio"
                          defaultValue="Radio"
                          filterValue=""
                        />
                        <span className="text-size-regular text-weight-regular w-form-label">All</span>
                      </ListFilterLabel>
                      <div className="filter-wrapper w-dyn-list">
                        <div role="list" className="filter-list w-dyn-items">
                          <div fs-cmsfilter-field="partner" role="listitem" className="filter-item-wrapper w-dyn-item">
                            <ListFilterLabel className="filter-item w-radio" as="label" filterValue="AI Infrastructure">
                              <ListFilterRadio
                                fs-list-value="AI Infrastructure"
                                className="w-form-formradioinput partnerships_radio w-radio-input"
                                fs-list-field="partner"
                                name="partner"
                                data-name="partner"
                                type="radio"
                                id="radio"
                                defaultValue="Radio"
                                filterValue="AI Infrastructure"
                              />
                              <span className="text-size-regular text-weight-regular w-form-label">
                                AI Infrastructure
                              </span>
                            </ListFilterLabel>
                          </div>
                          <div fs-cmsfilter-field="partner" role="listitem" className="filter-item-wrapper w-dyn-item">
                            <ListFilterLabel className="filter-item w-radio" as="label" filterValue="Cloud">
                              <ListFilterRadio
                                fs-list-value="Cloud"
                                className="w-form-formradioinput partnerships_radio w-radio-input"
                                fs-list-field="partner"
                                name="partner"
                                data-name="partner"
                                type="radio"
                                id="radio"
                                defaultValue="Radio"
                                filterValue="Cloud"
                              />
                              <span className="text-size-regular text-weight-regular w-form-label">Cloud</span>
                            </ListFilterLabel>
                          </div>
                          <div fs-cmsfilter-field="partner" role="listitem" className="filter-item-wrapper w-dyn-item">
                            <ListFilterLabel className="filter-item w-radio" as="label" filterValue="Data Engineering">
                              <ListFilterRadio
                                fs-list-value="Data Engineering"
                                className="w-form-formradioinput partnerships_radio w-radio-input"
                                fs-list-field="partner"
                                name="partner"
                                data-name="partner"
                                type="radio"
                                id="radio"
                                defaultValue="Radio"
                                filterValue="Data Engineering"
                              />
                              <span className="text-size-regular text-weight-regular w-form-label">
                                Data Engineering
                              </span>
                            </ListFilterLabel>
                          </div>
                          <div fs-cmsfilter-field="partner" role="listitem" className="filter-item-wrapper w-dyn-item">
                            <ListFilterLabel
                              className="filter-item w-radio"
                              as="label"
                              filterValue="Implementation Services"
                            >
                              <ListFilterRadio
                                fs-list-value="Implementation Services"
                                className="w-form-formradioinput partnerships_radio w-radio-input"
                                fs-list-field="partner"
                                name="partner"
                                data-name="partner"
                                type="radio"
                                id="radio"
                                defaultValue="Radio"
                                filterValue="Implementation Services"
                              />
                              <span className="text-size-regular text-weight-regular w-form-label">
                                Implementation Services
                              </span>
                            </ListFilterLabel>
                          </div>
                          <div fs-cmsfilter-field="partner" role="listitem" className="filter-item-wrapper w-dyn-item">
                            <ListFilterLabel className="filter-item w-radio" as="label" filterValue="Postgres Provider">
                              <ListFilterRadio
                                fs-list-value="Postgres Provider"
                                className="w-form-formradioinput partnerships_radio w-radio-input"
                                fs-list-field="partner"
                                name="partner"
                                data-name="partner"
                                type="radio"
                                id="radio"
                                defaultValue="Radio"
                                filterValue="Postgres Provider"
                              />
                              <span className="text-size-regular text-weight-regular w-form-label">
                                Postgres Provider
                              </span>
                            </ListFilterLabel>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="text-size-small text-weight-regular">
                    {'Showing '}
                    <ListFilterCount fs-list-element="results-count" className="text-span-5" as="span" total={21} />
                    {' partners'}
                  </p>
                </FormElement>
                <ListFilterWrapper
                  fs-list-filteringclass="is-list-filtering"
                  className="partnerships_featured-list-wrapper w-dyn-list"
                  as="div"
                >
                  <div fs-list-element="list" role="list" className="partnerships_featured-list w-dyn-items">
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Cloud']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/68ca657dc8ebef51de724650_AWS.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Cloud
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">AWS</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            The world’s leading cloud platform, powering scalable and resilient applications everywhere.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/aws"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Data Engineering']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/699bd89075b6aa27b9ecfac6_Bauplan.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Data Engineering
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Bauplan</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            Bauplan builds a serverless, code-first data lakehouse that lets teams define pipelines,
                            environments, and data changes in code, using Git-style branching, isolated runs, and atomic
                            publishes for AI-native data engineering.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/bauplan"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Implementation Services']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/68ca65ad707e934792a02824_BCG.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Implementation Services
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Boston Consulting Group</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            A global leader in strategy and transformation, helping enterprises modernize with
                            confidence.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/bcg"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Postgres Provider']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/699bd6183d57d149bdb598e1_Cockroach-Labs.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Postgres Provider
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Cockroach Labs</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            Cockroach Labs builds CockroachDB, a distributed SQL database designed for global scale,
                            high availability, and strong consistency, enabling teams to run mission-critical
                            applications across regions without downtime.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/cockroach-labs"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Data Engineering']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/68ca6595d173b9a1a7ce77c7_Confluent.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Data Engineering
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Confluent</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            The real-time data streaming platform enabling today’s event-driven architectures to thrive.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/confluent"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['AI Infrastructure']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/699bd611cb2787e79a906271_Databricks.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          AI Infrastructure
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Databricks</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            Databricks builds a unified data and AI platform that combines data engineering, analytics,
                            and machine learning on a lakehouse architecture, enabling teams to process data, train
                            models, and deploy AI at scale.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/databricks"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Data Engineering']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/699bd60d5769ad96910cf559_Drizzle.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Data Engineering
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Drizzle</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            Drizzle develops a lightweight, type-safe ORM and SQL toolkit that helps developers interact
                            with databases using modern TypeScript, offering a minimal, performance-focused alternative
                            to traditional ORMs.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/drizzle"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Data Engineering']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/699bd60640f9bfc8624c27f5_Fivetran.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Data Engineering
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Fivetran</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            Fivetran provides automated, zero-maintenance data pipelines that extract and load data from
                            hundreds of sources into cloud warehouses, lakes, and analytics systems so teams can use
                            data faster.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/fivetran"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Cloud']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/68ca6586581329fabd703344_GCP.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Cloud
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Google Cloud Platform</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>Flexible, AI-ready infrastructure built to handle modern, data-intensive applications.</p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/gcp"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['AI Infrastructure']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/699bd6013a3b1506aed461de_Llama-Index.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          AI Infrastructure
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">LlamaIndex</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            LlamaIndex builds a developer platform for creating AI agents and data-aware applications,
                            including document parsing, indexing, workflows, and open frameworks for retrieval,
                            automation, and production-ready GenAI systems.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/llamaindex"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Cloud']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/68ca658f6858f3c64fb2221a_Azure.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Cloud
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Microsoft Azure</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>Trusted enterprise-grade cloud services with the global reach to scale any workload.</p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/azure"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Postgres Provider']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/68fc40827ee1255af6c41a8c_Neon-Database-Logo.png"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Postgres Provider
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Neon</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            {
                              'Neon is a serverless Postgres platform that enables instant provisioning, autoscaling, and branching so developers can build scalable apps and AI\u00a0systems without managing database infrastructure.'
                            }
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/neon"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['AI Infrastructure']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/699bd5e9232267ab89dbef5c_OpenAI.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          AI Infrastructure
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">OpenAI</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            OpenAI builds advanced AI models and platforms, including ChatGPT and developer APIs, to
                            help people and organizations create applications, automate tasks, and solve complex
                            problems with reliable, scalable intelligence.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/openai"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Data Engineering']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/6a3b4dff28776137cd78b744_Parseable-Logo.png"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Data Engineering
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Parseable</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            {
                              'Parseable is an open source, column oriented, data lake platform, purpose built for observability. Teams use Parseable to unify telemetry data from across their infrastructure, apps, & agents.'
                            }
                          </p>
                          <p>{'\u200d'}</p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/parseable"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Postgres Provider']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/68fc3e992c0ff59fbbd74ab7_PlanetScale-Logo-White.png"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Postgres Provider
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">PlanetScale</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            PlanetScale is a fully managed relational database platform for Postgres, bringing you
                            scale, performance, and reliability — without sacrificing developer experience.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/planetscale"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['AI Infrastructure']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/699bd5ed3daa3c06f8f2d1f7_Pydantic-AI.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          AI Infrastructure
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Pydantic AI</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            Pydantic builds an end-to-end developer stack focused on type-safe apps, including its
                            open-source Python data validation library, AI agent framework, observability tools, and AI
                            workflow tooling for reliable software.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/pydantic-ai"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Postgres Provider']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/68ca659b405965c4594804b9_Supabase.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Postgres Provider
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Supabase</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            The open-source database and API platform helping developers ship faster with less
                            complexity.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/supabase"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Postgres Provider']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/699bd5e560e7f039bd377af8_Tiger-Data.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Postgres Provider
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Tiger Data</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            TigerData develops a Postgres-based platform for time-series and event data, delivering
                            scalable storage, fast analytics, and managed infrastructure for applications that rely on
                            real-time and historical data processing.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/tiger-data"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Implementation Services']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/68ca65a5e9dee5cfafa2a560_UST.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Implementation Services
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">UST</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            A global technology solutions provider driving digital transformation and enterprise
                            innovation at scale.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/ust"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Cloud']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/699bd5dfa4303fa9159d6a66_Vercel.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Cloud
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Vercel</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            Vercel builds a developer platform for deploying and scaling web and AI applications,
                            including hosting, CI/CD, serverless compute, and global infrastructure for fast, secure,
                            production-ready experiences.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/vercel"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                    <ListFilterItem
                      role="listitem"
                      className="partnerships_featured-item w-dyn-item"
                      as="div"
                      values={['Implementation Services']}
                    >
                      <div className="partnerships_header">
                        <div className="partner_logo-wrapper">
                          <img
                            src="/assets/cms/68ca65f1d5b0c68967313122_Zaelab.avif"
                            loading="lazy"
                            alt=""
                            className="partner_logo"
                          />
                        </div>
                        <p fs-list-field="partner" className="tagline-container text-size-small">
                          Implementation Services
                        </p>
                      </div>
                      <div className="partnerships_content">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h5">Zaelab</h3>
                        </div>
                        <div className="text-body-rich w-richtext">
                          <p>
                            Specialists in digital commerce modernization, delivering faster, reliable enterprise
                            experiences.
                          </p>
                        </div>
                      </div>
                      <div
                        data-wf--button--variant="secondary-large"
                        className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                      >
                        <a
                          href="/partnerships/zaelab"
                          className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                        >
                          <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">Learn more</div>
                          <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </ListFilterItem>
                  </div>
                </ListFilterWrapper>
                <FormDone className="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </FormDone>
                <FormFail className="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </FormFail>
              </ListFilterScope>
            </div>
          </div>
        </SlideIn>
        <div className="layout_glow-container">
          <div className="layout_glow-gradient" />
          <img
            src="/assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow.avif"
            loading="lazy"
            sizes="(max-width: 3999px) 100vw, 3999px"
            srcSet="/assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-500.avif 500w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-800.avif 800w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-1080.avif 1080w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-1600.avif 1600w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-2000.avif 2000w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-2600.avif 2600w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-3200.avif 3200w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow.avif 3999w"
            alt=""
            className="layout_code-glow"
          />
        </div>
      </section>
      <section className="section_partner-why">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-medium">
              <div className="partnership_component">
                <div className="text-align-center">
                  <div className="max-width-medium">
                    <div className="margin-bottom margin-small is-partner">
                      <h3 className="heading-style-h2">Partner with DBOS</h3>
                    </div>
                    <div className="margin-bottom margin-small">
                      <p className="text-body-active">Help more teams build durable, production-ready workflows.</p>
                    </div>
                    <div className="button-wrapper">
                      <a href="/contact" className="button text-align-center is-small w-inline-block">
                        <div className="text-block-4">Become a partner</div>
                        <div className="icon-arrow-right w-embed">
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M4.91083 10.4108L6.08917 11.5891L11.6783 5.99998L6.08917 0.410812L4.91083 1.58915L8.48833 5.16665H0.5V6.83331H8.48833L4.91083 10.4108Z"
                              fill="var(--_color-scheme-july-2025---background)"
                            />
                            {'\n'}
                          </svg>
                        </div>
                        <div className="icon-chevron-right w-embed">
                          <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            {'\n'}
                            <path
                              d="M2.08849 10.1249L6.84432 5.36911L2.08849 0.613281L0.910156 1.79161L4.48766 5.36911L0.910156 8.94661L2.08849 10.1249Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="layout-2col_list is-pricing">
                  <div id="w-node-_93c794c8-f918-594b-7020-18c8c0997390-95083d5b" className="layout-2col_item">
                    <div className="margin-bottom margin-tiny">
                      <div className="w-embed">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {'\n'}
                          <rect
                            x="0.5"
                            y="0.5"
                            width="39"
                            height="39"
                            rx="3.5"
                            stroke="url(#paint0_linear_8825_12016)"
                          />
                          {'\n'}
                          <path
                            d="M24.5628 17.72C24.1274 17.72 23.7651 17.575 23.4758 17.285C23.1864 16.9948 23.0418 16.6319 23.0418 16.1962C23.0418 15.7606 23.1866 15.3986 23.4763 15.1105C23.7659 14.8223 24.1283 14.6782 24.5633 14.6782C24.9983 14.6782 25.3604 14.8223 25.6498 15.1105C25.9391 15.3986 26.0838 15.7606 26.0838 16.1962C26.0838 16.6319 25.9391 16.9948 25.6498 17.285C25.3604 17.575 24.9981 17.72 24.5628 17.72ZM15.4403 17.72C15.0046 17.72 14.6427 17.575 14.3545 17.285C14.0663 16.9948 13.9223 16.6319 13.9223 16.1962C13.9223 15.7606 14.0661 15.3986 14.3538 15.1105C14.6414 14.8223 15.0028 14.6782 15.4378 14.6782C15.8728 14.6782 16.2349 14.8223 16.5243 15.1105C16.8136 15.3986 16.9583 15.7606 16.9583 16.1962C16.9583 16.6319 16.8138 16.9948 16.5248 17.285C16.2358 17.575 15.8743 17.72 15.4403 17.72ZM20 20.506C19.5643 20.506 19.2014 20.3623 18.9113 20.075C18.6211 19.7876 18.476 19.4253 18.476 18.988C18.476 18.5506 18.6211 18.1873 18.9113 17.898C19.2014 17.6088 19.5643 17.4642 20 17.4642C20.4357 17.4642 20.7986 17.6092 21.0888 17.8992C21.3789 18.1894 21.524 18.5523 21.524 18.988C21.524 19.4253 21.3789 19.7876 21.0888 20.075C20.7986 20.3623 20.4357 20.506 20 20.506ZM20 14.9342C19.5643 14.9342 19.2014 14.7891 18.9113 14.499C18.6211 14.2088 18.476 13.8459 18.476 13.4102C18.476 12.9746 18.6211 12.6116 18.9113 12.3215C19.2014 12.0315 19.5643 11.8865 20 11.8865C20.4357 11.8865 20.7986 12.0315 21.0888 12.3215C21.3789 12.6116 21.524 12.9746 21.524 13.4102C21.524 13.8459 21.3789 14.2088 21.0888 14.499C20.7986 14.7891 20.4357 14.9342 20 14.9342ZM19.9985 28.1135C19.6788 28.1135 19.3493 28.0875 19.01 28.0355C18.6707 27.9835 18.3427 27.9158 18.026 27.8325V24.186C18.026 23.5938 18.2113 23.0854 18.582 22.6607C18.9527 22.2362 19.4253 22.024 20 22.024C20.5747 22.024 21.0483 22.2362 21.421 22.6607C21.7937 23.0854 21.98 23.5938 21.98 24.186V27.8325C21.6593 27.9158 21.3288 27.9835 20.9885 28.0355C20.6482 28.0875 20.3182 28.1135 19.9985 28.1135ZM16.5023 27.3207C16.1816 27.1874 15.8609 27.0364 15.5403 26.8677C15.2196 26.6991 14.9156 26.5127 14.6283 26.3087C14.1536 25.9881 13.7768 25.5581 13.4978 25.0187C13.2188 24.4794 13.0793 23.8954 13.0793 23.2667C13.0793 22.8294 13.0376 22.412 12.9543 22.0145C12.8709 21.6168 12.7026 21.2485 12.4493 20.9095C12.2653 20.7071 11.9392 20.3863 11.471 19.947C11.0027 19.5076 10.5768 19.0943 10.1935 18.707C9.97284 18.4696 9.8625 18.2208 9.8625 17.9605C9.8625 17.7001 9.97184 17.4597 10.1905 17.2392C10.4258 17.0019 10.6632 16.8832 10.9025 16.8832C11.1418 16.8832 11.3782 17.0019 11.6115 17.2392L15.5153 20.912C15.8319 21.216 16.0756 21.5793 16.2463 22.002C16.4169 22.4248 16.5023 22.8538 16.5023 23.289V27.3207ZM23.4978 27.3207V23.2897C23.4978 22.8542 23.6039 22.4251 23.8163 22.0022C24.0286 21.5794 24.2951 21.216 24.6158 20.912L28.3885 17.2392C28.5925 17.0519 28.833 16.9582 29.11 16.9582C29.387 16.9582 29.6212 17.0519 29.8125 17.2392C30.0292 17.4597 30.1375 17.7001 30.1375 17.9605C30.1375 18.2208 30.0292 18.4696 29.8125 18.707C29.4252 19.0943 28.9973 19.4993 28.529 19.922C28.0608 20.3446 27.7348 20.6746 27.5508 20.912C27.2974 21.2493 27.1291 21.6168 27.0458 22.0145C26.9624 22.412 26.9208 22.829 26.9208 23.2655C26.9208 23.893 26.7813 24.4769 26.5023 25.0172C26.2233 25.5576 25.8458 25.9885 25.37 26.31C25.0842 26.4956 24.7808 26.6771 24.46 26.8545C24.1392 27.032 23.8184 27.1874 23.4978 27.3207Z"
                            fill="#F3F6F8"
                          />
                          {'\n'}
                          <defs>
                            {'\n'}
                            <linearGradient
                              id="paint0_linear_8825_12016"
                              x1="19.4792"
                              y1="0"
                              x2="39.2187"
                              y2="0"
                              gradientUnits="userSpaceOnUse"
                            >
                              {'\n'}
                              <stop stopColor="#C8F62E" />
                              {'\n'}
                              <stop offset="0.166667" stopColor="#87FB6B" />
                              {'\n'}
                              <stop offset="0.333333" stopColor="#3FFA9F" />
                              {'\n'}
                              <stop offset="0.5" stopColor="#00F5CC" />
                              {'\n'}
                              <stop offset="0.666667" stopColor="#00ECEC" />
                              {'\n'}
                              <stop offset="0.833333" stopColor="#48E1FE" />
                              {'\n'}
                              <stop offset="1" stopColor="#80D4FF" />
                              {'\n'}
                            </linearGradient>
                            {'\n'}
                          </defs>
                          {'\n'}
                        </svg>
                      </div>
                    </div>
                    <div className="margin-bottom margin-tiny">
                      <h4 className="heading-style-h5">Help customers scale</h4>
                    </div>
                    <p className="text-body-active text-size-regular">
                      Support your customers’ growth with fault-tolerant workflows that always deliver.
                    </p>
                  </div>
                  <div id="w-node-b3bb753e-9a29-0639-d8fe-530d792c9fe7-95083d5b" className="layout-2col_item">
                    <div className="margin-bottom margin-tiny">
                      <div className="w-embed">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {'\n'}
                          <rect
                            x="0.5"
                            y="0.5"
                            width="39"
                            height="39"
                            rx="3.5"
                            stroke="url(#paint0_linear_8825_12024)"
                          />
                          {'\n'}
                          <path
                            d="M18.925 21.1272L17.13 19.251C16.971 19.0765 16.7784 18.9892 16.5522 18.9892C16.3261 18.9892 16.1256 19.0661 15.951 19.22C15.7765 19.3966 15.6892 19.5978 15.6892 19.8235C15.6892 20.0491 15.7765 20.2493 15.951 20.424L18.3222 22.77C18.4936 22.944 18.6948 23.031 18.926 23.031C19.1571 23.031 19.3577 22.944 19.5277 22.77L24.049 18.274C24.2068 18.12 24.2857 17.9286 24.2857 17.7C24.2857 17.4713 24.1985 17.278 24.024 17.12C23.866 16.9828 23.6778 16.9184 23.4595 16.9267C23.2411 16.9351 23.0633 17.0098 22.926 17.151L18.925 21.1272ZM16.1925 30.0135L14.6542 27.3815L11.5782 26.7565C11.3671 26.7191 11.192 26.607 11.053 26.42C10.914 26.2328 10.8611 26.0341 10.8945 25.824L11.2445 22.8495L9.28748 20.5657C9.13814 20.4109 9.06348 20.2219 9.06348 19.9987C9.06348 19.7757 9.13814 19.5876 9.28748 19.4342L11.2445 17.1755L10.8945 14.201C10.8611 13.9908 10.914 13.7921 11.053 13.605C11.192 13.418 11.3671 13.3038 11.5782 13.2625L14.6562 12.6422L16.1925 9.98647C16.3038 9.80164 16.4642 9.67047 16.6737 9.59297C16.8831 9.51547 17.0915 9.52431 17.299 9.61947L20 10.8825L22.701 9.61947C22.9083 9.52814 23.1167 9.51605 23.3262 9.58322C23.5356 9.65022 23.696 9.7763 23.8075 9.96147L25.3687 12.6422L28.4217 13.2625C28.6329 13.3038 28.808 13.418 28.947 13.605C29.086 13.7921 29.1388 13.9908 29.1055 14.201L28.7555 17.1755L30.7125 19.4342C30.8618 19.5891 30.9365 19.7781 30.9365 20.0012C30.9365 20.2242 30.8618 20.4124 30.7125 20.5657L28.7555 22.8495L29.1055 25.824C29.1388 26.0341 29.086 26.2328 28.947 26.42C28.808 26.607 28.6329 26.7191 28.4217 26.7565L25.3707 27.3815L23.8075 30.0385C23.696 30.2236 23.5356 30.3497 23.3262 30.4167C23.1167 30.4839 22.9083 30.4718 22.701 30.3805L20 29.1175L17.299 30.3805C17.0916 30.4718 16.8832 30.4797 16.6737 30.4042C16.4644 30.3289 16.304 30.1986 16.1925 30.0135ZM17.3472 28.4592L19.9992 27.3367L22.726 28.4592L24.3892 25.9772L27.2902 25.2332L26.9962 22.275L28.9972 19.9995L26.9962 17.674L27.2902 14.7167L24.3892 14.0227L22.6782 11.5407L20.001 12.6625L17.274 11.5407L15.6125 14.0242L12.7157 14.7142L13.0037 17.674L11.0027 20L13.0037 22.276L12.7157 25.286L15.6115 25.9757L17.3472 28.4592Z"
                            fill="#F3F6F8"
                          />
                          {'\n'}
                          <defs>
                            {'\n'}
                            <linearGradient
                              id="paint0_linear_8825_12024"
                              x1="19.4792"
                              y1="0"
                              x2="39.2187"
                              y2="0"
                              gradientUnits="userSpaceOnUse"
                            >
                              {'\n'}
                              <stop stopColor="#C8F62E" />
                              {'\n'}
                              <stop offset="0.166667" stopColor="#87FB6B" />
                              {'\n'}
                              <stop offset="0.333333" stopColor="#3FFA9F" />
                              {'\n'}
                              <stop offset="0.5" stopColor="#00F5CC" />
                              {'\n'}
                              <stop offset="0.666667" stopColor="#00ECEC" />
                              {'\n'}
                              <stop offset="0.833333" stopColor="#48E1FE" />
                              {'\n'}
                              <stop offset="1" stopColor="#80D4FF" />
                              {'\n'}
                            </linearGradient>
                            {'\n'}
                          </defs>
                          {'\n'}
                        </svg>
                      </div>
                    </div>
                    <div className="margin-bottom margin-tiny">
                      <h4 className="heading-style-h5">{'Integrate with cloud & AI'}</h4>
                    </div>
                    <p className="text-body-active text-size-regular">
                      Our partnerships with AWS, GCP or OpenAI make integrating even easier.
                    </p>
                  </div>
                  <div id="w-node-c462f311-49fc-4918-2a6a-5aea48ea4590-95083d5b" className="layout-2col_item">
                    <div className="margin-bottom margin-tiny">
                      <div className="w-embed">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {'\n'}
                          <rect
                            x="0.5"
                            y="0.5"
                            width="39"
                            height="39"
                            rx="3.5"
                            stroke="url(#paint0_linear_8825_12014)"
                          />
                          {'\n'}
                          <path
                            d="M28.995 14.9C28.9784 14.7319 28.9194 14.5708 28.8235 14.4318C28.7277 14.2928 28.5981 14.1803 28.447 14.105L20.447 10.105C20.3081 10.0355 20.1549 9.99927 19.9995 9.99927C19.8442 9.99927 19.6909 10.0355 19.552 10.105L11.552 14.105C11.4013 14.1807 11.2721 14.2933 11.1765 14.4323C11.0809 14.5713 11.0219 14.7321 11.005 14.9C10.994 15.007 10.044 25.667 19.594 29.914C19.7216 29.9716 19.86 30.0014 20 30.0014C20.14 30.0014 20.2784 29.9716 20.406 29.914C29.956 25.667 29.006 15.008 28.995 14.9ZM20 27.897C13.231 24.625 12.911 17.642 12.966 15.635L20 12.118L27.029 15.633C27.066 17.622 26.701 24.651 20 27.897Z"
                            fill="#F3F6F8"
                          />
                          {'\n'}
                          <path
                            d="M19 20.586L16.707 18.293L15.293 19.707L19 23.414L24.707 17.707L23.293 16.293L19 20.586Z"
                            fill="#F3F6F8"
                          />
                          {'\n'}
                          <defs>
                            {'\n'}
                            <linearGradient
                              id="paint0_linear_8825_12014"
                              x1="19.4792"
                              y1="0"
                              x2="39.2187"
                              y2="0"
                              gradientUnits="userSpaceOnUse"
                            >
                              {'\n'}
                              <stop stopColor="#C8F62E" />
                              {'\n'}
                              <stop offset="0.166667" stopColor="#87FB6B" />
                              {'\n'}
                              <stop offset="0.333333" stopColor="#3FFA9F" />
                              {'\n'}
                              <stop offset="0.5" stopColor="#00F5CC" />
                              {'\n'}
                              <stop offset="0.666667" stopColor="#00ECEC" />
                              {'\n'}
                              <stop offset="0.833333" stopColor="#48E1FE" />
                              {'\n'}
                              <stop offset="1" stopColor="#80D4FF" />
                              {'\n'}
                            </linearGradient>
                            {'\n'}
                          </defs>
                          {'\n'}
                        </svg>
                      </div>
                    </div>
                    <div className="margin-bottom margin-tiny">
                      <h4 className="heading-style-h5">Enterprise-level security</h4>
                    </div>
                    <p className="text-body-active text-size-regular">
                      {"We're built to meet SOC 2 compliance, GDPR & CCPA standards."}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_testimonial-large">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large">
              <div className="testimonial_wrapper w-dyn-list">
                <div fs-list-element="list" role="list" className="w-dyn-items">
                  <div role="listitem" className="w-dyn-item">
                    <div className="testimonial34_card">
                      <div className="testimonial34_left">
                        <img
                          fs-list-element="tab-link"
                          loading="lazy"
                          alt=""
                          src="/assets/cms/69d4bd94ec2b1771c2ef8782_supabase.svg"
                          className="testimonial34_tab-logo"
                        />
                        <div className="text-size-large">
                          {
                            '"I love the design of DBOS. If you\'re a gamer, it\'s like having a “save point” in your programs. If a function fails, a new function starts, picking up at the last checkpoint." - Paul Copplestone, CEO'
                          }
                        </div>
                        <div className="testimonial31_client">
                          <div className="testimonial31_client-image-wrapper">
                            <img
                              loading="lazy"
                              src="/assets/images/67e21d345ceb6064084225f8_9c06ac8b23608a9546f6b6d6cb15b7f7_Paul-Copplestone.avif"
                              alt=""
                              className="testimonial31_customer-image"
                            />
                          </div>
                          <div className="testimonial_client-info">
                            <div className="text-size-medium text-weight-medium">Paul Copplestone</div>
                            <p className="text-body-active">{'CEO & Co-Founder'}</p>
                          </div>
                        </div>
                      </div>
                      <div
                        id="w-node-e617418c-b5b0-f9e6-5898-9bd7c4588b40-95083d5b"
                        style={{ backgroundImage: 'url("/assets/cms/684a933a88d1d70be4a0d6ab_Supabase.png")' }}
                        className="testimonial34_right"
                      >
                        <div className="div-block-52">
                          <div className="tagline-container">
                            <div className="text-style-tagline">Software</div>
                          </div>
                          <div className="div-block-49">
                            <h3 className="heading-style-h5 is-list">
                              Supabase: Running Durable Workflows in Postgres
                            </h3>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/supabase"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div className="div-block-51" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_faq">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-small">
              <div className="faq_component">
                <div className="max-width-medium">
                  <div className="margin-bottom margin-medium">
                    <div className="text-align-center">
                      <h3 className="heading-style-h2">Frequently Asked Questions</h3>
                    </div>
                  </div>
                </div>
                <div className="max-width-large">
                  <div className="w-layout-grid faq_list">
                    <FaqAccordion className="faq_accordion">
                      <FaqQuestion className="faq_question">
                        <h5 className="text-size-medium text-align-left">Does DBOS work with major cloud providers?</h5>
                        <FaqIcon className="faq_icon-wrappper">
                          <div className="icon-embed-small-3 w-embed">
                            <svg
                              width="100%"
                              height="100%"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M25.3333 15.667V16.3336C25.3333 16.7018 25.0349 17.0003 24.6667 17.0003H17V24.667C17 25.0351 16.7015 25.3336 16.3333 25.3336H15.6667C15.2985 25.3336 15 25.0351 15 24.667V17.0003H7.3333C6.96511 17.0003 6.66663 16.7018 6.66663 16.3336V15.667C6.66663 15.2988 6.96511 15.0003 7.3333 15.0003H15V7.33365C15 6.96546 15.2985 6.66699 15.6667 6.66699H16.3333C16.7015 6.66699 17 6.96546 17 7.33365V15.0003H24.6667C25.0349 15.0003 25.3333 15.2988 25.3333 15.667Z"
                                fill="currentColor"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </FaqIcon>
                      </FaqQuestion>
                      <FaqAnswer className="faq_answer">
                        <div className="margin-bottom margin-small">
                          <p className="text-body-active text-size-regular">
                            {'Yes, DBOS has partnerships with providers including AWS, Google Cloud Platform & Google.'}
                          </p>
                        </div>
                      </FaqAnswer>
                    </FaqAccordion>
                    <FaqAccordion className="faq_accordion">
                      <FaqQuestion className="faq_question">
                        <h5 className="text-size-medium text-align-left">
                          Does DBOS have partnerships within the AI infrastructure space?
                        </h5>
                        <FaqIcon className="faq_icon-wrappper">
                          <div className="icon-embed-small-3 w-embed">
                            <svg
                              width="100%"
                              height="100%"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M25.3333 15.667V16.3336C25.3333 16.7018 25.0349 17.0003 24.6667 17.0003H17V24.667C17 25.0351 16.7015 25.3336 16.3333 25.3336H15.6667C15.2985 25.3336 15 25.0351 15 24.667V17.0003H7.3333C6.96511 17.0003 6.66663 16.7018 6.66663 16.3336V15.667C6.66663 15.2988 6.96511 15.0003 7.3333 15.0003H15V7.33365C15 6.96546 15.2985 6.66699 15.6667 6.66699H16.3333C16.7015 6.66699 17 6.96546 17 7.33365V15.0003H24.6667C25.0349 15.0003 25.3333 15.2988 25.3333 15.667Z"
                                fill="currentColor"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </FaqIcon>
                      </FaqQuestion>
                      <FaqAnswer className="faq_answer">
                        <div className="margin-bottom margin-small">
                          <p className="text-body-active text-size-regular">
                            Yes! DBOS has partnered with AI leaders like OpenAI, LlamaIndex and Pydantic AI, to provide
                            reliability for production-ready autonomous agents.
                          </p>
                        </div>
                      </FaqAnswer>
                    </FaqAccordion>
                    <FaqAccordion className="faq_accordion">
                      <FaqQuestion className="faq_question">
                        <h5 className="text-size-medium text-align-left">
                          Can my company reach out to begin a new partnership with DBOS?
                        </h5>
                        <FaqIcon className="faq_icon-wrappper">
                          <div className="icon-embed-small-3 w-embed">
                            <svg
                              width="100%"
                              height="100%"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M25.3333 15.667V16.3336C25.3333 16.7018 25.0349 17.0003 24.6667 17.0003H17V24.667C17 25.0351 16.7015 25.3336 16.3333 25.3336H15.6667C15.2985 25.3336 15 25.0351 15 24.667V17.0003H7.3333C6.96511 17.0003 6.66663 16.7018 6.66663 16.3336V15.667C6.66663 15.2988 6.96511 15.0003 7.3333 15.0003H15V7.33365C15 6.96546 15.2985 6.66699 15.6667 6.66699H16.3333C16.7015 6.66699 17 6.96546 17 7.33365V15.0003H24.6667C25.0349 15.0003 25.3333 15.2988 25.3333 15.667Z"
                                fill="currentColor"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </FaqIcon>
                      </FaqQuestion>
                      <FaqAnswer className="faq_answer">
                        <div className="margin-bottom margin-small">
                          <p className="text-body-active text-size-regular">
                            Yes, DBOS is open to new collaborations and encourages interested companies to reach out
                            through the official contact form or community Discord to begin a partnership discussion.
                          </p>
                        </div>
                      </FaqAnswer>
                    </FaqAccordion>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
    </SiteLayout>
  );
}
